/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../Fixes';
import Builder from '../../../../../../Builder';
import './flag_groups';
import '../../message/context';
import './multipass';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "flags": {
                "nested": {
                  "v2": {
                    "nested": {
                      "message": {
                        "nested": {
                          "DeviceContextFlags": {
                            "fields": {
                              "flagGroups": {
                                "type": ".squareup.feature.relay.flags.v2.message.FlagGroups",
                                "id": 2,
                                "rule": "required"
                              },
                              "squareMobileDevice": {
                                "type": ".squareup.feature.relay.flags.message.SquareMobileDevice",
                                "id": 1
                              },
                              "squareBrowser": {
                                "type": ".squareup.feature.relay.flags.message.SquareBrowser",
                                "id": 3
                              },
                              "browser": {
                                "type": ".squareup.feature.relay.flags.message.Browser",
                                "id": 4
                              }
                            },
                            "nested": {
                              "context": {
                                "oneof": [
                                  "squareMobileDevice",
                                  "squareBrowser",
                                  "browser"
                                ]
                              }
                            }
                          },
                          "ContextFlags": {
                            "fields": {
                              "deviceFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.DeviceContextFlags",
                                "id": 1,
                                "rule": "optional"
                              },
                              "multipassGroup": {
                                "type": ".squareup.feature.relay.flags.v2.message.MultipassGroup",
                                "id": 2
                              }
                            },
                            "nested": {
                              "authorized_flags": {
                                "oneof": [
                                  "multipassGroup"
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.DeviceContextFlags && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.ContextFlags) {
	$root.addJSON(jsonData);
}

/**
 * Unauthenticated
 *
 * SOURCE DeviceContextFlags @ squareup/feature/relay/flags/v2/message/context.proto at 14:1
 */
export const DeviceContextFlags = $root.lookupType('squareup.feature.relay.flags.v2.message.DeviceContextFlags');
fixType(DeviceContextFlags);
Builder.createAndAttachToType(DeviceContextFlags);
/**
 * Authenticated
 *
 * SOURCE ContextFlags @ squareup/feature/relay/flags/v2/message/context.proto at 26:1
 */
export const ContextFlags = $root.lookupType('squareup.feature.relay.flags.v2.message.ContextFlags');
fixType(ContextFlags);
Builder.createAndAttachToType(ContextFlags);
